import { Theme, useTheme } from "@amx/ux-twoui-theming";
import { ISearchBoxStyles, SearchBox as FluentSearchBox } from "@fluentui/react";
import React from "react";
import { useComponentLogger } from "../../shared/logging";
import { InteractiveElementProps, validateProps } from "../../shared/props";
import { getColorFromCorrectPalette } from "../../styles/colors";

export interface SearchBoxProps extends InteractiveElementProps {
    /**
     * Callback executed when the user presses enter in the search box.
     */
    readonly onSearch?: (newValue: string) => void;
    /**
     * Callback function for when the typed input for the SearchBox has changed.
     */
    readonly onChange?: (event?: React.ChangeEvent<HTMLInputElement>, newValue?: string) => void;
    /**
     * Placeholder for the search box.
     */
    readonly placeholder?: string;
    /**
     * Value for the search box.
     */
    readonly value?: string;
}

const getSearchBoxStyle = (
    theme: Theme
): ISearchBoxStyles  => {
    const backgroundColor = getColorFromCorrectPalette(theme, "neutralHigh");
    return {
        root: {
            backgroundColor
        }
    };
};

export const SearchBox: React.FC<SearchBoxProps> = ({
    "aria-label": ariaLabel,
    ...otherProps
}) => {
    useComponentLogger("SearchBox", otherProps.id);
    const theme = useTheme();
    const style = getSearchBoxStyle(theme);
    validateProps("SearchBox", otherProps);

    return (
        <FluentSearchBox ariaLabel={ariaLabel} styles={otherProps.disabled ? undefined : style} {...otherProps}  />
    );
};
